import EditIcon from '@mui/icons-material/Edit';
import CardAction from '../../../../../../../../components/card/CardAction';

export default function RenameFileAction({
  className,
  onClick,
  disabled,
} = {
  className: '',
  onClick: () => null,
  disabled: true,
}) {
  return (
    <CardAction
      icon={<EditIcon aria-hidden='false' />}
      actionHandler={onClick}
      label='Rename'
      className={`btn-primary ${className}`}
      ariaLabel='Rename file'
      title='Rename file'
      data-test='rename-file-action'
      disabled={disabled}
      tabIndex={0}
      aria-hidden='false'
    />
  );
}
